
<script>
import { defineComponent, inject } from 'vue'

export default defineComponent({
  name: "Events",
  setup() {
    const hydrate = inject("hydrate")

    const { prefetch } = hydrate({
      //prefetch:["contactUs"],
      metadata(meta, prefetchData) {
        meta.addTitle("Golden Oaks Motel | Events")
      //   const seo = contactUs.seo[0]
      //   meta.addTitle(seo.page_title)
      //   meta.addCanonical()
      //   meta.addMetaItem([
      //     { name:'description', content: seo.page_description },
      //     { name:'og:title', content: seo.open_graph_title },
      //     { name:'og:description', content: seo.open_graph_description },
      //     { name:'og:image', content: pathname(seo.open_graph_image.guid) },
      //     { name:'og:image:alt', content: seo.open_graph_image_alt } 
      //   ])
      },
      // preload: ({contactUs}) => [pathname(contactUs.header_image.guid)],
      // watch({ Contact }, watchReveal) {
      //   watchReveal(header,
      //     () => (Contact.preload == 1 && Contact.prefetch == 1)
      //   )
      // }
    })

    return {}

  },
});
</script>


<template>

  <div id="top" class="page-header events wf-section">
    <div class="page-header-overlay menu">
      <div class="container w-container">
        <div class="section-intro-block">
          <h2 class="section-intro-title">OUR Events</h2>
          <h2 class="section-intro-title subtitle">Event information and local attractions</h2>
        </div>
      </div>
    </div>
  </div>
  <div class="section white wf-section">
    <div class="container w-container">
      <div class="events-row w-row">
        <div class="contact-us-column w-col w-col-6 w-col-small-6 w-col-tiny-6">
          <div class="event-overview-image local">
            <a href="#" class="image-link-block w-inline-block"></a>
          </div>
        </div>
        <div class="event-column-right w-col w-col-6 w-col-small-6 w-col-tiny-6">
          <div class="intro-title">Open Daily</div>
          <a href="#" class="blog-link-title">Our Casino <br />
          </a>
          <div class="section-divider-line"></div>
          <p>Open Mon-Fri 4PM to Midnight, Sat-Sun 1PM to Midnight. The Hidden Oaks Cafe is open 7 days a week from 5pm - 10pm.</p>
        </div>
      </div>
      <div class="events-row w-row">
        <div class="contact-us-column w-col w-col-6 w-col-small-6 w-col-tiny-6">
          <div class="event-overview-image concven">
            <a href="#" class="image-link-block w-inline-block"></a>
          </div>
        </div>
        <div class="event-column-right w-col w-col-6 w-col-small-6 w-col-tiny-6">
          <div class="intro-title">Open 24/7</div>
          <a href="#" class="blog-link-title">Convenience store <br />
          </a>
          <div class="section-divider-line"></div>
          <p>The Hidden Oaks Convenience store is located about 1 mile north of The Golden Oaks Motel, offering a wide range of refreshments and snacks, to include made-to-order take-and-bake pizzas and soft-serve ice cream. They also serve as our area smoke shop, carrying a wide variety of native-owned and major brand cigarettes. <br />
            <br />
          </p>
        </div>
      </div>
    </div>
  </div>

</template>